export const locale = {
    lang: 'pl',
    data: {
        'Name': 'Nazwa',
        'Category': 'Kategoria',
        'New': 'Nowy',
        'Resources': 'Zasoby',
        'New resource': 'Nowy zasób',
        'selected': 'wybrane',
        'total': 'razem',
        'Save': 'Zapisz',
        'Add category': 'Dodaj kategorię',
        'Description': 'Opis',
        'Enable calendar': 'Uruchom kalendarz',
        'Resource data': 'Dane zasobu',
        'Parent category': 'Kategoria nadrzędna',
        'New category': 'Nowa kategoria',
        'Add': 'Dodaj',
        'Name is required!': 'Nazwa jest wymagana!',
        'Edit': 'Edycja',
        'Actions': 'Akcje',
        'Serial number': 'Numer seryjny',
        'Enable automatic payments': 'Włącz automatyczne płatności',
        'Is active': 'Urządzenie aktywne',
        'Is registered': 'Urządzenie zarejestrowane',
        'Always active in calendar': 'Zawsze aktywne w kalendarzu',
        'Last activity': 'Ostatnia aktywność',
        'Last success': 'Ostatnie powodzenie',
        'Last error': 'Ostatni błąd',
        'Fiscal printer': 'Drukarka fiskalna',
        'Required credits': 'Wymagane kredyty',
        'Reservation time': 'Czas rezerwacji',
        'Calendar priority': 'Priorytet w kalendarzu'
    }
};
